export default __webpack_public_path__ + "static/icon-text-70f6efdab82344c548a4c78eeb8ca748.png";